import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';

export default class RoleBindingModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.checked = 0;
    if (vnode.attrs.getChargeList) {
      this.getChargeList = () => {
        vnode.attrs.getChargeList();
      };
    }
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small role-modal';
  }

  title() {
    return;
  }

  onRoleItemClick(item) {
    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/userRole',
        body: { srvId: item.srvId, rid: item.rid, pkgId: item.pkgId },
      })
      .then((res) => {
        app.data['currentRole'] = item;
        this.getChargeList ? this.getChargeList() : true;
        return res;
      });
  }

  content() {
    const roleGroups = Object.entries(app.data['roleInfo'] || {}).filter(([, roles]) => Array.isArray(roles) && roles.length > 0);

    return (
      <div className="role-modal-box">
        <div className="role-modal-header">{app.translator.trans('dl-pay.forum.operation.select_role')}</div>
        <div className="role-lists-box">
          <div className="role-lists-box-item">
            {roleGroups.map(([pkgId, roles]) => (
              <div className="role-lists" key={pkgId}>
                <div className="role-list-title">{roles[0].pkgName}</div>
                <div className="role-list">
                  {roles.map((item, index) => {
                    const isCurrentRole =
                      app.data['currentRole'] &&
                      app.data['currentRole'].srvId === item.srvId &&
                      app.data['currentRole'].rid === item.rid &&
                      app.data['currentRole'].pkgId === item.pkgId;

                    return (
                      <div
                        key={`${pkgId}-${item.srvId}-${item.rid}-${index}`}
                        className={`role-item ${isCurrentRole ? 'item-check' : ''}`}
                        onclick={() => this.onRoleItemClick(item)}
                      >
                        <div className="role-icon">
                          {isCurrentRole ? (
                            <div className="icon-img checked">
                              <img className="checked-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-goubai.png`}></img>
                              <img
                                className="role-img"
                                src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/headicon/${item.faceId}.png`}
                              ></img>
                            </div>
                          ) : (
                            <div className="icon-img">
                              <img
                                className="role-img"
                                src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/headicon/${item.faceId}.png`}
                              ></img>
                            </div>
                          )}
                        </div>
                        <div className="role-info">
                          <div className="role-top">
                            <div className="role-name">{item.name}</div>
                            <div className="role-lv">
                              {app.translator.trans('dl-pay.forum.user.lv')}.{item.lev}
                            </div>
                          </div>
                          <div className="role-bottom">
                            <div className="role-id">
                              {app.translator.trans('dl-pay.forum.user.uID')}: {item.rid}
                            </div>
                            <div className="role-district-server">{app.translator.trans('dl-pay.forum.user.srvId', { srvId: item.srvId })}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
